import React from "react";
import "./ContactUs.css";

export default function ContactUs() {
  return (
    <div className="contactus1-container">
      <h1 className="contactus1-title">Contact Us</h1>
      <p className="contactus1-intro">
        We're here to help. Reach out to us at any of our locations below.
      </p>

      <div className="contactus1-locations">
        <div className="contactus1-card">
          <h2 className="contactus1-location-title">Mumbai Office</h2>
          <p className="contactus1-detail">
            <strong>Address:</strong> HW 1121, Bharat Diamond Bourse, Bandra
            Kurla Complex,
            <br />
            Bandra(East), Mumbai-400051, India
          </p>
          <p className="contactus1-detail">
            <strong>Phone:</strong> (+91-22) 4046 4444
          </p>
          <p className="contactus1-detail">
            <strong>Email:</strong> net@pansuriyaimpex.com
          </p>
        </div>

        <div className="contactus1-card">
          <h2 className="contactus1-location-title">Surat Office</h2>
          <p className="contactus1-detail">
            <strong>Address:</strong> Plot no.. 11/12, Opp. Community Hall,
            Vastadevdi Road,
            <br />
            Katargam, Surat-395004, India.
          </p>
          <p className="contactus1-detail">
            <strong>Phone:</strong> (+91-261) 2501900
          </p>
          <p className="contactus1-detail">
            <strong>Email:</strong> surat@pansuriyaimpex.com
          </p>
        </div>
      </div>
    </div>
  );
}
